import {Plugins} from '@packages/systems/wfdl';
import Icon from './Icon';

export const plugin = Plugins.PrivilegedPlugin({atoms: {Icon}});
